import { Modal, Typography } from "../../../components";

interface DeleteModalProps {
  modalVisibility: boolean;
  modalVisibilityControls: () => void;
  onConfirm: () => Promise<void>;
}

export const DeleteBidsModal = ({ modalVisibility, modalVisibilityControls, onConfirm }: DeleteModalProps) => {
  return (
    <Modal
      open={modalVisibility}
      onClose={modalVisibilityControls}
      title="Você tem certeza que deseja excluir esta oferta?"
      onConfirm={onConfirm}
      confirmLabel="Confirmar"
    >
      <div style={{ width: 400 }}>
        <Typography>
          Esta ação é irreversível e será deletada permanentemente.
        </Typography>
      </div>
    </Modal>
  );
};
